import { FigmaIcon } from "#components/ui/FigmaIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const figmaManifest: IntegrationManifest = {
    key: "figma",
    displayName: "Figma",
    nameKey: "channels.figma",
    descriptionKey: "figmaDescription",
    trayDescriptionKey: "composerTrayDescriptions.figma",
    cardDescriptionKey: "connectIntegration.descriptions.figma",
    connectedContentKeys: ["figmaDesignFiles"],
    brandColor: "#F24E1E",
    iconUrl: IconAssets.Figma,
    iconUrlAlt: IconAssets.FigmaAlt,
    glyph: FigmaIcon,
    channelType: "UserFigmaMcp",
    // Remote-MCP citations resolve via customProperties.integrationKey, not a DataSource.
    dataSources: []
};
